export default {
  background:
    'linear-gradient(to right, rgb(77, 77, 77) 0%, rgb(117, 116, 116) 100%)',
};
